import { render, staticRenderFns } from "./ConsultasView.vue?vue&type=template&id=4a05ecf9&scoped=true"
import script from "./ConsultasView.vue?vue&type=script&lang=js"
export * from "./ConsultasView.vue?vue&type=script&lang=js"
import style0 from "./ConsultasView.vue?vue&type=style&index=0&id=4a05ecf9&prod&lang=scss&scoped=true"
import style1 from "./ConsultasView.vue?vue&type=style&index=1&id=4a05ecf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a05ecf9",
  null
  
)

export default component.exports